import React, { useState } from "react";
import { toast } from "react-toastify";
import { useMarkShippedMutation, useOrdersQuery } from "../../service/orderApi";
const OrderList = () => {
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);
  const { data, isLoading } = useOrdersQuery({ page: page });
  const [selectedOrder, setSelectedOrder] = useState({});
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [markShipped] = useMarkShippedMutation();
  const handleMark = (item) => {
    if (selectedOrders.includes(item)) {
      // `item` is an order id (string); compare by value, not by `._id`.
      setSelectedOrders(selectedOrders.filter((s) => s !== item));
    } else {
      setSelectedOrders([...selectedOrders, item]);
    }
  };

  const updateOrders = (task) => {
    markShipped({ ids: selectedOrders, task: task }).then((res) => {
      if (res.data.status) {
        toast.success(res?.data?.message);
        setSelectedOrders([]);
      } else {
        toast.error(res?.data?.message);
      }
    });
  };
  return (
    <div>
      <div className="bg-gray-700 my-[30px] rounded p-[10px]">
        <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <h3 className="text-[20px] font-bold text-white">Orders</h3>
          <div className="flex flex-col gap-2 sm:flex-row">
            <button
              onClick={() => updateOrders("shipped")}
              disabled={selectedOrders.length === 0}
              className="rounded bg-green-500 px-4 py-2 text-white hover:bg-green-600 disabled:cursor-not-allowed disabled:bg-green-300 sm:w-[180px]"
            >
              Mark as Shipped
            </button>
            <button
              onClick={() => updateOrders("canceled")}
              disabled={selectedOrders.length === 0}
              className="rounded bg-red-500 px-4 py-2 text-white hover:bg-red-600 disabled:cursor-not-allowed disabled:bg-red-300 sm:w-[180px]"
            >
              Mark as Canceled
            </button>
          </div>
        </div>

        {isLoading ? (
          <p className="py-10 text-center text-gray-300">Loading orders…</p>
        ) : (data?.data?.length ?? 0) === 0 ? (
          <p className="py-10 text-center text-gray-300">No orders found.</p>
        ) : (
        <div class="relative overflow-x-auto shadow-md bg-gray-900 sm:rounded-lg">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead>
              <tr className="shadow shadow-gray-700">
                <th scope="col" class="px-6 py-3">
                  Action
                </th>
                <th scope="col" class="px-6 py-3">
                  Name
                </th>
                <th scope="col" class="px-6 py-3">
                  Transaction Id
                </th>
                <th scope="col" class="px-6 py-3">
                  Shipping Address
                </th>
                <th scope="col" class="px-6 py-3">
                  Post Code
                </th>
                <th scope="col" class="px-6 py-3">
                  Phone
                </th>
                <th scope="col" class="px-6 py-3">
                  Total
                </th>
                <th scope="col" class="px-6 py-3">
                  Coupon Used
                </th>
                <th scope="col" class="px-6 py-3">
                  Status
                </th>
                <th scope="col" class="px-6 py-3">
                  View Details
                </th>
                <th scope="col" class="px-6 py-3">
                  Delete
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.data?.map((d) => (
                <tr
                  className={`shadow shadow-gray-700 ${
                    d?.status === "shipped" && "text-green-700"
                  } ${d?.status === "canceled" && "text-red-700"}`}
                >
                  <td class="px-6 py-4">
                    <input
                      type="checkbox"
                      checked={selectedOrders?.includes(d?._id)}
                      onChange={() => handleMark(d?._id)}
                      className="focus:outline-none focus:border-0 h-[20px] w-[20px]"
                      id="sCheck"
                    />
                  </td>
                  <td class="px-6 py-4">{d?.shipping?.name}</td>
                  <td class="px-6 py-4">{d?.txId}</td>
                  <td class="px-6 py-4">{`${d?.shipping?.address?.line1}, ${d?.shipping?.address?.city}, ${d?.shipping?.address?.state}, ${d?.shipping?.address?.country}`}</td>
                  <td class="px-6 py-4">{d?.shipping?.address?.postal_code}</td>
                  <td class="px-6 py-4">{d?.shipping?.phone}</td>
                  <td class="px-6 py-4">£{parseFloat(d?.amount).toFixed(2)}</td>
                  <td class="px-6 py-4">
                    {d?.couponDetails?._id ? (
                      <>
                        Got {d?.couponDetails?.discount}% off with code:{" "}
                        {d?.couponDetails?.couponCode}
                      </>
                    ) : (
                      <>Not Used</>
                    )}
                  </td>

                  <td class="px-6 py-4">
                    {d?.status === "succeeded" && "Paid"}
                    {d?.status === "shipped" && "Shipped"}
                    {d?.status === "canceled" && "Canceled"}
                  </td>
                  <td class="px-6 py-4">
                    <button
                      onClick={() => {
                        setShow(true);
                        setSelectedOrder(d);
                      }}
                      className="bg-[#47db47] px-[20px] py-[7px] rounded text-[white] hover:bg-[#399439] active:bg-[#9b3232]"
                    >
                      Details
                    </button>
                  </td>
                  <td class="px-6 py-4">
                    <button
                      //   onClick={() => {
                      //     setSelected(d);
                      //     setDeleteModal(true);
                      //   }}
                      className="bg-[#ce3737] px-[20px] py-[7px] rounded text-[white] hover:bg-[#ff3939] active:bg-[#9b3232]"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        )}
        <div className="flex flex-wrap justify-between items-center gap-3 mt-[15px]">
          <div className="text-[#fff] font-bold">
            Page {page} of {data?.totalPages} Pages
          </div>
          <div className="text-[#fff] font-bold">
            Total {data?.totalItems} Items
          </div>
          <div>
            {page > 1 ? (
              <button
                onClick={() => setPage(page - 1)}
                className="text-[#fff] border-[1px] border-[#fff] px-[20px] py-[8px] w-[100px] rounded font-bold mr-[10px] hover:bg-white hover:text-[black]"
              >
                Previous
              </button>
            ) : (
              <button
                disabled
                className="text-[grey] border-[1px] border-[grey] px-[20px] py-[8px] w-[100px] rounded font-bold mr-[10px] "
              >
                Previous
              </button>
            )}
            {page < data?.totalPages ? (
              <button
                onClick={() => setPage(page + 1)}
                className="text-[#fff] border-[1px] border-[#fff] px-[20px] py-[8px] w-[100px] rounded font-bold ml-[10px] hover:bg-white hover:text-[black]"
              >
                Next
              </button>
            ) : (
              <button
                disabled
                className="text-[grey] border-[1px] border-[grey] px-[20px] py-[8px] w-[100px] rounded font-bold ml-[10px]"
              >
                Next
              </button>
            )}
          </div>
        </div>
      </div>

      {show && (
        <div class="fixed top-0 left-0 right-0 bottom-0 z-50 pt-[200px] w-full flex justify-center p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
          <div class="relative w-full max-w-md max-h-full">
            <div class="relative rounded-lg shadow bg-gray-600">
              <button
                onClick={() => setShow(false)}
                type="button"
                class="absolute top-3 right-2.5 text-gray-300 bg-transparent rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center hover:text-white"
                data-modal-hide="authentication-modal"
              >
                <svg
                  class="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span class="sr-only">Close modal</span>
              </button>
              <div class="px-6 py-6 lg:px-8">
                <h3 className="text-center text-[20px] font-bold text-white mb-[20px]">
                  Order Details
                </h3>
                {selectedOrder?.products?.map((c) => (
                  <div className="flex flex-col py-1 px-[7px] border-t border-b bg-[#050303] text-white">
                    <div className="flex items-start space-x-4">
                      <img
                        src={c?.images[0]}
                        alt="Item"
                        className="w-[70px] h-[70px] object-cover"
                      />
                      <div className="flex flex-col flex-grow ">
                        <p className="text-[14px] mb-[24px]">
                          {" "}
                          {c?.category === "fashion" && c?.subCategory === "clothes" ? (
                            <>
                              {c?.counter?.name}={c?.counter?.quantity} x {c?.name}
                            </>
                          ) : (
                            <>
                              {c?.count} x {c?.name}
                            </>
                          )}
                        </p>
                      </div>
                      <div className="flex flex-col">
                        <p className="text-[22px] ">£{parseFloat(c?.price).toFixed(2)}</p>
                      </div>
                    </div>
                  </div>
                ))}
                <button
                  onClick={() => setShow(false)}
                  className="bg-[#47db47] mt-[15px] w-[100%] px-[20px] py-[7px] rounded text-[white] hover:bg-[#399439] active:bg-[#9b3232]"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderList;
